import React, { useContext } from 'react'
import { Button } from 'components/ui'
import { PriorityModalContext } from 'contexts/PriorityModalContext'
import { APPSUMO_ADDON_URL } from 'components/ui/utils/constant'
import { HiOutlineExternalLink } from 'react-icons/hi'

const AppSumoAddonModal = () => {

    const { closeModalPriority } = useContext(PriorityModalContext)

    const handleBuyAddon = () => {
        if (!APPSUMO_ADDON_URL) return
        window.open(APPSUMO_ADDON_URL, '_blank', 'noopener,noreferrer')
        closeModalPriority()
    }

    return (
        <div className='flex flex-col'>
            <img
                src="/img/others/appsumo-banner.jpg"
                alt="AppSumo"
                className='object-fit object-center object-cover w-[120%] max-w-none h-[150px] -mt-6 -mx-[10%] !mb-12'
            />
            <div className='flex flex-col gap-6 mb-12 px-2'>
                <h1 className='text-tertiary-900 dark:text-white mega-title text-center'>
                    You're out of AI media credits
                </h1>
                <p className='text-center text-lg text-gray-600 dark:text-gray-300'>
                    As an AppSumo licensee, you can unlock more image and video credits by grabbing an AppSumo add-on. Your current license stays intact — add-ons stack on top.
                </p>
            </div>

            <div className='flex justify-end gap-2 p-4 -m-6 w-auto mt-10 border-t border-tertiary-100 dark:border-gray-700'>
                <Button onClick={closeModalPriority}>
                    Maybe later
                </Button>
                <Button
                    variant="solid"
                    disabled={!APPSUMO_ADDON_URL}
                    onClick={handleBuyAddon}
                    icon={<HiOutlineExternalLink />}
                >
                    Get more credits on AppSumo
                </Button>
            </div>
        </div>
    )
}

export default AppSumoAddonModal
